import gql from 'graphql-tag';

export namespace RadioFragments {
  export const Radio = gql`
    fragment Radio on Radio {
      id
      title
      description
      fileKey
      sortOrder
      url
    }
  `;
}
